import { parseFloatSafe } from "@omni/utils/number.utils";
import queryString from "query-string";
import { useEffect, useState } from "react";

import * as CalculatorStepTracker from "@/services/tracking/trackers/tools/calculators/calculatorStep.tracker";
import { CALCULATOR_KEYS } from "@/services/tracking/trackers/tools/calculators/config";

import Calculation from "./calculation/calculation.component";
import Result from "./result/result.component";

const CementplateCalculator = () => {
    const q = queryString.parse(location.search);

    const [cementplateLength, setCementplateLength] = useState(
        q.cementplateLength?.toString() || "0"
    );

    const [cementplateWidth, setCementplateWidth] = useState(
        q.cementplateWidth?.toString() || "0"
    );

    const [cementplateThickness, setCementplateThickness] = useState(
        q.cementplateThickness?.toString() || "0"
    );

    const [cementplateArea, setCementplateArea] = useState(0);
    const [cementplateVolume, setCementplateVolume] = useState(0);

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        setCementplateArea(determineCementplateArea());
        setCementplateVolume(determineCementplateVolume());
        CalculatorStepTracker.trackStart(CALCULATOR_KEYS.cementPlate);
    }, []);

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        setCementplateArea(determineCementplateArea());
        setCementplateVolume(determineCementplateVolume());
    }, [cementplateLength, cementplateWidth, cementplateThickness]);

    const determineCementplateArea = () => {
        return (
            parseFloatSafe(cementplateLength, 0) *
            parseFloatSafe(cementplateWidth, 0)
        );
    };

    const determineCementplateVolume = () => {
        const length = parseFloatSafe(cementplateLength, 0);
        const width = parseFloatSafe(cementplateWidth, 0);
        const height = parseFloatSafe(cementplateThickness, 0) * 0.01; // convert cm to m
        return length * width * height;
    };

    const setCalculationValue = (field: string, value: string) => {
        switch (field) {
            case "cementplateLength": {
                setCementplateLength(value);
                break;
            }
            case "cementplateWidth": {
                setCementplateWidth(value);
                break;
            }
            case "cementplateThickness": {
                setCementplateThickness(value);
                break;
            }
        }
        CalculatorStepTracker.trackSubmit(CALCULATOR_KEYS.cementPlate);
    };

    const calculationProps = {
        setCalculationValue: setCalculationValue,
        cementplateLength: cementplateLength,
        cementplateWidth: cementplateWidth,
        cementplateThickness: cementplateThickness
    };
    const resultProps = {
        cementplateArea: cementplateArea,
        cementplateVolume: cementplateVolume,
        mailParams: {
            cementplateLength: cementplateLength,
            cementplateWidth: cementplateWidth,
            cementplateThickness: cementplateThickness
        }
    };

    return (
        <div id="calculator">
            <Calculation {...calculationProps} />
            <Result {...resultProps} />
        </div>
    );
};

export { CementplateCalculator };
